export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xs">E</span>
              </div>
              <span className="font-bold text-white text-sm">EMI Online Calc</span>
            </div>
            <p className="text-xs leading-relaxed">
              India's most trusted EMI calculator. Providing a complete breakdown of interest rates and tenure for home loans, car loans, and personal loans.
            </p>
          </div>

          {/* Loan Calculators */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Loan Calculators</h4>
            <ul className="space-y-2 text-xs">
              <li><a href="#home-loan" className="hover:text-white transition-colors">HDFC Home Loan Calculator</a></li>
              <li><a href="#home-loan" className="hover:text-white transition-colors">SBI Housing Loan EMI</a></li>
              <li><a href="#car-loan" className="hover:text-white transition-colors">India Car Loan Calculator</a></li>
              <li><a href="#car-loan" className="hover:text-white transition-colors">HDFC Second Hand Car Loan</a></li>
              <li><a href="#personal-loan" className="hover:text-white transition-colors">5 Lakh Personal Loan Calculator</a></li>
            </ul>
          </div>

          {/* Niche Tools */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Niche Tools</h4>
            <ul className="space-y-2 text-xs">
              <li><a href="#niche" className="hover:text-white transition-colors">Gold Loan Calculator Online</a></li>
              <li><a href="#niche" className="hover:text-white transition-colors">Two Wheeler EMI Calculator</a></li>
              <li><a href="#niche" className="hover:text-white transition-colors">Washing Machine EMI Calculator</a></li>
              <li><a href="#calculator" className="hover:text-white transition-colors">Personal Loan Calculator with GST</a></li>
              <li><a href="#calculator" className="hover:text-white transition-colors">Housing Loan Partial Payment Calculator</a></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">About</h4>
            <ul className="space-y-2 text-xs">
              <li><a href="#eligibility" className="hover:text-white transition-colors">Loan Eligibility Calculator</a></li>
              <li><a href="#calculator" className="hover:text-white transition-colors">Personal Loan Calculator INR</a></li>
              <li><a href="#calculator" className="hover:text-white transition-colors">Online SBI Personal Loan Calculator</a></li>
              <li><a href="#car-loan" className="hover:text-white transition-colors">Online SBI Car Loan Calculator</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs">&copy; {new Date().getFullYear()} EMI Online Calculator. All rights reserved.</p>
          <p className="text-xs text-slate-500">
            Disclaimer: Calculations are indicative. Please verify with your bank for exact figures.
          </p>
        </div>
      </div>
    </footer>
  )
}
